import "./ExcelTables.css";

export default function ExcelColumnsTable({ columns = [] }) {
  if (!columns.length) return null;

  return (
    <section className="excel-table-card">
      <div className="excel-table-card__header">
        <h3>Kolommen</h3>
        <p>Gedetecteerde Excel-kolommen en mappingrollen.</p>
      </div>

      <div className="excel-table-card__wrapper">
        <table>
          <thead>
            <tr>
              <th>Kolom</th>
              <th>Header</th>
              <th>Key</th>
              <th>Rol</th>
            </tr>
          </thead>

          <tbody>
            {columns.map((column, index) => (
              <tr key={`${column.column}-${index}`}>
                <td>{column.column || "-"}</td>
                <td>{column.header || "-"}</td>
                <td>
                  <code>{column.key || "-"}</code>
                </td>
                <td>
                  <span
                    className={`excel-table-card__badge excel-table-card__badge--${column.role}`}
                  >
                    {column.role || "-"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
